import React, { useState } from "react";
import {
  Button,
  Flex,
  FormLabel,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  Text,
  Box,
} from "@chakra-ui/react";
import { toast } from "react-toastify";
import ModalLoginPin from "./modalLoginPin";
import Login from "../../../services/loginApi";

interface ModalSelectEmailProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  email: string;
  submitLogin: (pinCode: string) => Promise<void>;
}

const ModalSelectEmail: React.FC<ModalSelectEmailProps> = ({
  isOpen,
  setIsOpen,
  email,
  submitLogin,
}) => {
  const [loading, setLoading] = useState(false);
  const [showCodeModal, setShowCodeModal] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  async function sendCodeRequest() {
    try {
      setLoading(true);
      await Login.PostSms(email, "login", "S");
      setLoading(false);
      setShowCodeModal(true);
    } catch (error) {
      setLoading(false);
      toast.error("Erro ao solicitar o código!");
    }
  }

  const handlePinSubmit = async (pin: string) => {
    try {
      console.log("PIN recebido:", pin);
      await submitLogin(pin);
    } catch (error) {
      toast.error(`Erro ao enviar código de verificação para login: ${error}`);
    }
  };

  return (
    <>
      {isOpen && (
        <Box
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="rgba(0, 0, 0, 0.5)"
          backdropFilter="blur(10px)"
          zIndex="modal"
        />
      )}
      <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
        <ModalContent>
          <Flex w={"100%"} justifyContent={"center"} my={2}>
            <Text fontSize={"xl"} fontWeight={"bold"}>
              Autenticação de dois fatores
            </Text>
          </Flex>
          <ModalBody>
            <FormLabel>
              Você receberá um código por SMS ou E-mail, caso seja Código Fixo
              ou Google Auth, é só digitar o codigo!
            </FormLabel>
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={"#f1f5f9"} mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              background={"blue"}
              color={"white"}
              isLoading={loading}
              onClick={sendCodeRequest}
            >
              Prosseguir
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <ModalLoginPin
        isOpen={showCodeModal}
        setIsOpen={setShowCodeModal}
        onSubmit={handlePinSubmit}
        submitLogin={submitLogin}
      />
    </>
  );
};

export default ModalSelectEmail;
